import React from "react";

function Overlay({overlayActive, children}) {
    return (
    <div className={overlayActive ? "hide" : "overlay"}>
        {children}
    </div>
    )
}

export default Overlay;